import axios from "axios";
import { API_BASE_URL } from "./ApiConfig";
import Cookies from "js-cookie";
import { Modal } from "antd";

const Navi = (props) => {
  Modal.error({ title: "You do not have permission to access this section." });
  var link = document.createElement("a");
  link.href = "/" + props;
  link.click();
};

const fetchData = async (url) => {
  const navigator = Navi;
  const response = await axios
    .get(API_BASE_URL + url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + Cookies.get("access_token"),
      },
    })
    .catch((reason) => {
      if (reason.response.status == 403) {
        Modal.error({
          title: "You do not have permission to access this section.",
        });
        navigator("sign-in");
      }
      if (reason.response.status == 400 && reason.response.data.data.message) {
        return reason.response.data.data.message;
      }
      return reason.response.data.message;
    });

  return response;
};
const fetchBlobData = async (url) => {
  const navigator = Navi;
  const response = await axios
    .get(API_BASE_URL + url, {
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + Cookies.get("access_token"),
        Accept: "application/pdf",
      },
      responseType: "blob",
    })
    .catch((reason) => {
      if (reason.response.status == 403) {
        Modal.error({
          title: "You do not have permission to access this section.",
        });
        navigator("sign-in");
      }
      if (reason.response.status == 400 && reason.response.data.data.message) {
        return reason.response.data.data.message;
      }
      return reason.response.data.message;
    });

  return response;
};

const fetchDataWithParams = async (url, params) => {
  const navigator = Navi;
  const response = await axios
    .get(API_BASE_URL + url, {
      params: { params },
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + Cookies.get("access_token"),
      },
    })
    .catch((reason) => {
      if (reason.response.status == 403) {
        Modal.error({
          title: "You do not have permission to access this section.",
        });
        navigator("sign-in");
      }
      if (reason.response.status == 400 && reason.response.data.data.message) {
        return reason.response.data.message;
      }
      return reason.response.message;
    });
  return response;
};

const postData = async (url, data) => {
  const navigator = Navi;
  const respons = await axios
    .post(API_BASE_URL + url, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + Cookies.get("access_token"),
      },
    })
    .catch((reason) => {
      if (reason.response.status == 403) {
        Modal.error({
          title: "You do not have permission to access this section.",
        });
        navigator("sign-in");
      }
      if (reason.response.status == 400 && reason.response.data.data.message) {
        return reason.response.data.data.message;
      }
      return reason.response.data.message;
    });

  return respons;
};
const postFormData = async (url, data) => {
  const navigator = Navi;
  const respons = await axios
    .post(API_BASE_URL + url, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + Cookies.get("access_token"),
        Accept: "application/json",
      },
    })
    .catch((reason) => {
      if (reason.response.status == 403) {
        Modal.error({
          title: "You do not have permission to access this section.",
        });
        navigator("sign-in");
      }
      if (reason.response.status == 400 && reason.response.data.data.message) {
        return reason.response.data.data.message;
      }
      return reason.response.data.message;
    });

  return respons;
};
const putFormData = async (url, data) => {
  const navigator = Navi;
  const respons = await axios
    .put(API_BASE_URL + url, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + Cookies.get("access_token"),
        Accept: "application/json",
      },
    })
    .catch((reason) => {
      if (reason.response.status == 403) {
        Modal.error({
          title: "You do not have permission to access this section.",
        });
        navigator("sign-in");
      }
      if (reason.response.status == 400 && reason.response.data.data.message) {
        return reason.response.data.data.message;
      }
      return reason.response.data.message;
    });

  return respons;
};
const putGetFormData = async (url, data) => {
  const navigator = Navi;
  const respons = await axios
    .put(API_BASE_URL + url, data, {
      responseType: "arraybuffer",
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: "Bearer " + Cookies.get("access_token"),
        Accept:
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      },
    })
    .catch((reason) => {
      if (reason.response.status == 403) {
        Modal.error({
          title: "You do not have permission to access this section.",
        });
        navigator("sign-in");
      }
      if (reason.response.status == 400 && reason.response.data.data.message) {
        return reason.response.data.data.message;
      }
      return reason.response.data.message;
    });

  return respons;
};
const putData = async (url, data) => {
  const navigator = Navi;
  const respons = await axios
    .put(API_BASE_URL + url, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + Cookies.get("access_token"),
      },
    })
    .catch((reason) => {
      if (reason.response.status == 403) {
        Modal.error({
          title: "You do not have permission to access this section.",
        });
        navigator("sign-in");
      }
      if (reason.response.status == 400 && reason.response.data.data.message) {
        return reason.response.data.data.message;
      }
      return reason.response.data.message;
    });

  return respons;
};

const postWithoutToket = async (url, data) => {
  const navigator = Navi;
  const respons = await axios
    .post(API_BASE_URL + url, data, {
      headers: {
        "Content-Type": "application/json",
      },
    })
    .catch((reason) => {
      if (reason.response.status == 403) {
        Modal.error({
          title: "You do not have permission to access this section.",
        });
        navigator("sign-in");
      }
      if (reason.response.status == 400 && reason.response.data.data.message) {
        return reason.response.data.data.message;
      }
      return reason.response.data.message;
    });

  return respons;
};

const deleteData = async (url) => {
  const navigator = Navi;
  const respons = await axios
    .delete(API_BASE_URL + url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + Cookies.get("access_token"),
      },
    })
    .catch((reason) => {
      if (reason.response.status == 403) {
        Modal.error({
          title: "You do not have permission to access this section.",
        });
        navigator("sign-in");
      }
      return reason.response.data.message;
    });

  return respons;
};

export {
  fetchData,
  postData,
  postWithoutToket,
  putData,
  deleteData,
  postFormData,
  putFormData,
  putGetFormData,
  fetchDataWithParams,
  fetchBlobData,
};
